import { useFloatingContext, FloatingWrapper } from '@elliemae/ds-floating-context';
import { styled } from '@elliemae/ds-system';
import React, { useContext } from 'react';
import {
  ControlledDateTimePickerDatatestid,
  DSControlledDateTimePickerName,
  DSControlledDateTimePickerSlots,
} from '../../../constants/index.js';
import { ControlledDateTimePickerContext } from '../../../ControlledDateTimePickerCTX.js';
import { CalendarContent } from './CalendarContent.js';
import { CalendarContext } from './CalendarContext.js';

const StyledFloatingWrapper = styled(FloatingWrapper, {
  name: DSControlledDateTimePickerName,
  slot: DSControlledDateTimePickerSlots.CONTEXTUAL_MENU.CALENDAR,
})``;

export const CalendarWrapper = (): JSX.Element | null => {
  const { isControllerOnly, getProps } = useContext(ControlledDateTimePickerContext);
  const { referenceElement, closeCalendar } = useContext(CalendarContext);

  const {
    refs,
    floatingStyles,
    context,
    isOpen: isFloatingOpen,
  } = useFloatingContext({
    externallyControlledIsOpen: !isControllerOnly && !!referenceElement,
    externalReferenceElement: referenceElement,
    withoutAnimation: true,
    customOffset: [0, 0],
    onClickOutside: isControllerOnly ? undefined : closeCalendar,
  });

  if (isControllerOnly) return <CalendarContent />;
  if (!referenceElement) return null;

  return (
    <StyledFloatingWrapper
      innerRef={refs.setFloating}
      isOpen={isFloatingOpen}
      floatingStyles={floatingStyles}
      context={context}
      data-testid={ControlledDateTimePickerDatatestid.CONTEXTUAL_MENU.CALENDAR}
      getOwnerProps={getProps}
      aria-label="calendar header"
      role="dialog"
    >
      <CalendarContent />
    </StyledFloatingWrapper>
  );
};
